var map = {
	"./appstore.svg": "99f8",
	"./appstore_white.svg": "e903",
	"./arrow_down.svg": "7ed6",
	"./arrow_tail_right.svg": "baa7",
	"./bed.svg": "219f",
	"./book.svg": "e23f",
	"./cash.svg": "caee",
	"./celebrate.svg": "289a",
	"./googleplay.svg": "4610",
	"./home.svg": "ae05",
	"./laptop.svg": "1aef",
	"./logo_pulda.svg": "15c2",
	"./lunch.svg": "ad2e",
	"./name.svg": "c0e9",
	"./shortcut.svg": "2f7e",
	"./shortcut_white.svg": "8b76",
	"./work.svg": "3cbb"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e321";